export default __webpack_public_path__ + "static/media/68t.f23b829f.jpg";